import React from 'react';
import logo from '../assets/stema-whitelogo.png';

export default function AwaitingApproval({ name, onLogout }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        background: 'linear-gradient(135deg, #1A2541 0%, #243058 100%)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        boxSizing: 'border-box',
        padding: '24px'
      }}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          padding: '48px 40px',
          maxWidth: '480px',
          width: '100%',
          boxShadow: '0 25px 50px rgba(0, 0, 0, 0.35)',
          textAlign: 'center'
        }}
      >
        {/* Logo on dark pill */}
        <div
          style={{
            backgroundColor: '#1A2541',
            borderRadius: '10px',
            padding: '14px 24px',
            display: 'inline-block',
            marginBottom: '32px'
          }}
        >
          <img src={logo} alt="Stema" style={{ height: '28px', display: 'block' }} />
        </div>

        {/* Hourglass icon */}
        <div
          style={{
            width: '68px',
            height: '68px',
            backgroundColor: '#fef3c7',
            border: '2px solid #fcd34d',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            fontSize: '30px'
          }}
        >
          ⏳
        </div>

        <h1
          style={{
            margin: '0 0 10px',
            fontSize: '26px',
            fontWeight: '700',
            color: '#111827'
          }}
        >
          Awaiting Approval
        </h1>

        {name && (
          <p style={{ margin: '0 0 16px', fontSize: '15px', color: '#6b7280' }}>
            Hello, <strong style={{ color: '#111827' }}>{name}</strong>
          </p>
        )}

        <p
          style={{
            margin: '0 0 36px',
            fontSize: '15px',
            color: '#4b5563',
            lineHeight: '1.65'
          }}
        >
          Your account has been created successfully. Your access is currently pending
          approval from management. You will be able to use the system once your account
          is approved.
        </p>

        <button
          onClick={onLogout}
          style={{
            padding: '12px 36px',
            backgroundColor: '#1A2541',
            color: '#ffffff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '15px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#243058'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#1A2541'; }}
        >
          Log Out
        </button>
      </div>
    </div>
  );
}
